var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-hu",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M512 512H0V0h512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#388d00",
    d: "M512 512H0V341.3h512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d43516",
    d: "M512 170.8H0V.1h512z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHu);
export default __webpack_public_path__ + "static/media/hu.cb329e885950a7c054075d78aa6f1364.svg";
export { ForwardRef as ReactComponent };